import { notify } from '@kyvg/vue3-notification'
import i18n from '@/i18n'

// Plain module, so there is no `this.$t` here - go through the i18n instance directly.
const t = key => i18n.global.t(key)

export default {
  error (msg, error) {
    // If message is provided, use it directly (already translated)
    // Otherwise try to extract from error object
    if (!msg && error) {
      if (error.response && error.response.data && error.response.data.error) {
        msg = error.response.data.error
      } else if (error.message) {
        msg = error.message
      }
    }
    msg = msg || 'Unknown error'
    notify({
      title: t('notifications.error'),
      text: msg,
      type: 'error',
    })
  },
  sucess (msg) {
    notify({
      title: t('notifications.success'),
      text: msg,
      type: 'success',
    })
  },
  info (msg) {
    notify({
      title: t('notifications.info'),
      text: msg,
    })
  },
  warning (msg) {
    notify({
      title: t('notifications.warning'),
      text: msg,
      type: 'warn',
    })
  },
}
